module.exports = __webpack_public_path__ + "img/phone.6210189d.svg";